import { render, staticRenderFns } from "./PlaceMediaFloatBtns.vue?vue&type=template&id=8b5810ee&"
import script from "./PlaceMediaFloatBtns.vue?vue&type=script&lang=js&"
export * from "./PlaceMediaFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports